/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { equityInvestmentPageVisitedPostRequestSchema } from './equityInvestmentPageVisitedPostRequestSchema.ts';
import { equityInvestmentPageVisitedPostResponseSchema } from './equityInvestmentPageVisitedPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postEquityInvestmentPageVisited200Schema = z.lazy(() => equityInvestmentPageVisitedPostResponseSchema);

/**
 * @description 505 response
 */
export const postEquityInvestmentPageVisited505Schema = z.any();

export const postEquityInvestmentPageVisitedMutationRequestSchema = z.lazy(
  () => equityInvestmentPageVisitedPostRequestSchema
);

export const postEquityInvestmentPageVisitedMutationResponseSchema = z.lazy(
  () => postEquityInvestmentPageVisited200Schema
);
